function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2d2fe78e\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/home/colin/Dev/free_paul_thibault-portfolio_2017/src/styles/_variables.scss\",\"/home/colin/Dev/free_paul_thibault-portfolio_2017/src/styles/_tools.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Shapes.vue")
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2d2fe78e\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/home/colin/Dev/free_paul_thibault-portfolio_2017/src/styles/_variables.scss\",\"/home/colin/Dev/free_paul_thibault-portfolio_2017/src/styles/_tools.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./Shapes.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Shapes.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2d2fe78e\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Shapes.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d2fe78e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Shapes.vue
// module id = 160
// module chunks = 1